import { Component, computed, input, output } from '@angular/core';
import {
  formatReleaseDate,
  RELEASE_UPDATE_CATEGORY_LABELS,
  RELEASE_UPDATE_CATEGORY_SECTIONS,
  type ReleaseNoteDto,
  type ReleaseUpdateItemDto,
} from '../../../../../../shared/models/release-notes.models';
import { AdminIconComponent } from '../../../../../../shared/admin/admin-icon.component';
import { ReleaseImageGalleryComponent } from '../release-image-gallery/release-image-gallery.component';

@Component({
  selector: 'app-release-accordion',
  standalone: true,
  imports: [AdminIconComponent, ReleaseImageGalleryComponent],
  templateUrl: './release-accordion.component.html',
  styleUrl: './release-accordion.component.scss',
})
export class ReleaseAccordionComponent {
  readonly releases = input.required<ReleaseNoteDto[]>();
  readonly expandedIds = input<Set<string>>(new Set());
  readonly expandedIdsChange = output<Set<string>>();

  readonly categorySections = RELEASE_UPDATE_CATEGORY_SECTIONS;
  readonly categoryLabels = RELEASE_UPDATE_CATEGORY_LABELS;

  readonly sortedReleases = computed(() =>
    [...this.releases()].sort(
      (a, b) => new Date(b.releaseDate).getTime() - new Date(a.releaseDate).getTime(),
    ),
  );

  isExpanded(id: string): boolean {
    return this.expandedIds().has(id);
  }

  toggle(id: string): void {
    const next = new Set(this.expandedIds());
    if (next.has(id)) {
      next.delete(id);
    } else {
      next.add(id);
    }
    this.expandedIdsChange.emit(next);
  }

  formatDate(dateStr: string): string {
    return formatReleaseDate(dateStr);
  }

  itemsForCategory(release: ReleaseNoteDto, category: string): ReleaseUpdateItemDto[] {
    return release.updateItems
      .filter((item) => item.category === category)
      .sort((a, b) => a.displayOrder - b.displayOrder);
  }

  hasCategoryItems(release: ReleaseNoteDto, category: string): boolean {
    return this.itemsForCategory(release, category).length > 0;
  }
}
